const CONSENT_KEY = "cookie_consent";
const CONSENT_VERSION = "1.0";

// Prefixes used by game caches — only these get cleared on functional opt-out
const FUNCTIONAL_PREFIXES = [
  "spot_cache_",
  "mcq_cache_",
  "comprehension_cache_",
  "book_comp_",
];

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Re-prompt if the policy version has changed
    if (parsed.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent({ functional, analytics }) {
  const consent = {
    version: CONSENT_VERSION,
    essential: true, // always true — cannot be disabled
    functional: Boolean(functional),
    analytics: Boolean(analytics),
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));

  // If functional storage was refused, remove any cached game data immediately
  if (!functional) {
    removeFunctionalStorage();
  }

  return consent;
}

export function removeFunctionalStorage() {
  const keys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && FUNCTIONAL_PREFIXES.some((p) => k.startsWith(p))) keys.push(k);
  }
  keys.forEach((k) => localStorage.removeItem(k));
}

export function hasConsented() {
  return getConsent() !== null;
}
